import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const Category = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [primaryCategory, setPrimaryCategory] = useState([]);
  const [secondaryCategory, setSecondaryCategory] = useState([]);
  const [isEnable, setIsEnable] = useState({
    save: false,
  });

  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (
      eventName === "primary_category" ||
      eventName === "secondary_category"
    ) {
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
        if (eventName === "primary_category") {
          setPrimaryCategory(event);
        } else {
          setSecondaryCategory(event);
        }
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
      }
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateCategory = {
      userId: inputData.userId,
      primary_category: inputData.primary_category,
      secondary_category: inputData.secondary_category,
    };
    dispatch(updateProfleAction(inputData.userId, updateCategory));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const category = {
        userId: props.profile.userId,
        primary_category: props.profile.primary_category,
        secondary_category: props.profile.secondary_category,
      };
      setInputData(category);
    }

    if (props.category.length > 0) {
      if (inputData.primary_category) {
        const primaryCaegoryData = props.category.find(
          (category) => category.id === inputData.primary_category
        );
        if (
          primaryCaegoryData.function === props.primaryFunctionId &&
          props.primarySectorId != null
        ) {
          setPrimaryCategory(primaryCaegoryData);
        } else {
          setPrimaryCategory(null);
        }
      }
      if (inputData.secondary_category) {
        const secondaryCategoryData = props.category.find(
          (category) => category.id === inputData.secondary_category
        );
        if (
          secondaryCategoryData.function === props.secondaryFunctionId &&
          props.secondarySectorId != null
        ) {
          setSecondaryCategory(secondaryCategoryData);
        } else {
          setSecondaryCategory(null);
        }
      }
    }
  }, [
    props.profile,
    props.category,
    props.primaryFunctionId,
    props.secondaryFunctionId,
    props.primarySectorId,
    props.secondarySectorId,
  ]);

  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Category"}
      />
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Category</h5>
          <div className="row">
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <label className="field-label">Primary Category Experience</label>
            </div>
            <div className="col-md-6 col-12 ">
              <Select
                id="primary_category"
                name="primary_category"
                value={
                  props.category &&
                  props.category.find(
                    (category) => category.id === inputData.primary_category
                  )
                }
                options={
                  props.category &&
                  props.category.filter((val) =>
                    [props.primaryFunctionId].includes(val["function"])
                  )
                }
                getOptionLabel={(option) => option.category}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "primary_category")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
                isDisabled={props.primarySectorId === null ? true : false}
              />
              {inputData.primary_category != null &&
              inputData.primary_category === true ? (
                <Link className="edit-btn" to="">
                  <span>
                    <img src="/assets/images/icons/warning.svg" alt="" />
                  </span>
                </Link>
              ) : (
                ""
              )}
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "2%" }}>
              <label className="field-label">
                Secondary Category Experience
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="secondary_category"
                name="secondary_category"
                value={
                  props.category &&
                  props.category.find(
                    (category) => category.id === inputData.secondary_category
                  )
                }
                options={
                  props.category &&
                  props.category.filter((val) =>
                    [props.secondaryFunctionId].includes(val["function"])
                  )
                }
                getOptionLabel={(option) => option.category}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "secondary_category")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
                isDisabled={
                  inputData.primary_category === null ||
                  props.secondarySectorId === null
                    ? true
                    : false
                }
              />
              {inputData.secondary_category != null &&
              inputData.secondary_category === true ? (
                <Link className="edit-btn" to="">
                  <span>
                    <img src="/assets/images/icons/warning.svg" alt="" />
                  </span>
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const category = state.admin.category;

  return {
    user: user,
    profile: profile,
    category: category,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Category);
